import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import type { Extension } from '../types/index';

export function useExtension(id: string) {
  const [extension, setExtension] = useState<Extension | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const extensionRef = doc(db, 'extensions', id);
    const unsubscribe = onSnapshot(extensionRef, 
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setExtension({
            id: doc.id,
            name: data.name,
            description: data.description,
            version: data.version,
            author: data.author,
            downloadUrl: data.downloadUrl,
            thumbnailUrl: data.thumbnailUrl,
            categoryId: data.categoryId,
            category: data.category,
            downloads: data.downloads || 0,
            totalRatings: data.totalRatings || 0,
            totalRatingSum: data.totalRatingSum || 0,
            averageRating: data.averageRating || 0,
            createdAt: data.createdAt?.toDate?.() || new Date(),
            updatedAt: data.updatedAt?.toDate?.() || new Date()
          });
        } else {
          setError('Extension not found');
        }
        setLoading(false);
      },
      () => {
        setError('Failed to load extension');
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [id]);

  return { extension, loading, error };
} 